import { useEffect } from 'react';
import { X } from 'lucide-react';
import type { BadgeDefinition } from '../lib/supabase';

interface BadgeUnlockModalProps {
  badge: BadgeDefinition;
  onClose: () => void;
}

export function BadgeUnlockModal({ badge, onClose }: BadgeUnlockModalProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center relative animate-badge-unlock shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="mb-4">
          <div className="text-6xl mb-2 animate-bounce-in">{badge.icon}</div>
          <div className="text-yellow-500 font-bold text-sm uppercase tracking-wider mb-2">
            Badge Unlocked!
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">{badge.name}</h3>
          <p className="text-gray-600 text-sm">{badge.description}</p>
        </div>

        <div className="space-y-2">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-yellow-400 to-orange-500 w-full animate-shimmer"></div>
          </div>
        </div>

        <div className="absolute -top-4 -left-4 text-4xl animate-confetti">⭐</div>
        <div className="absolute -top-6 -right-2 text-3xl animate-confetti" style={{ animationDelay: '0.1s' }}>✨</div>
        <div className="absolute -bottom-2 -left-2 text-3xl animate-confetti" style={{ animationDelay: '0.2s' }}>🎉</div>
        <div className="absolute -bottom-4 -right-4 text-4xl animate-confetti" style={{ animationDelay: '0.15s' }}>🌟</div>
      </div>
    </div>
  );
}
